// -----------------------------------------------------------------------------
// Anaglyphic, Netherlands @ 2023.
// See README in the root project for more information.
// -----------------------------------------------------------------------------

// Plugins
import i18n from "./i18n";
import pinia from "@/stores";
import vuetify from "./vuetify";
import { router } from "@/router/router";
import { PerfectScrollbarPlugin } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/style.css";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fad } from "@fortawesome/pro-duotone-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { fat } from "@fortawesome/pro-thin-svg-icons";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { vue3Debounce } from "vue-debounce";
import { initSentry } from "./sentry";
import VCalendar from "v-calendar";
import "./vcalander/style.css";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
// import nl from "dayjs/locale/nl";
import en from "dayjs/locale/en";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekday from "dayjs/plugin/weekday";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { App } from "vue";
import { registerRoutesAndTranslations } from "@/modules";
import FloatingVue from "floating-vue";
import initChartJs from "./chartjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(weekOfYear);
dayjs.extend(weekday);

dayjs.extend(duration);
dayjs.extend(relativeTime);

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/Amsterdam");

dayjs.extend(customParseFormat);

dayjs.locale(en);

// -----------------------------------------------------------------------------

export async function registerPlugins(app: App) {
	app.use(pinia);

	await registerRoutesAndTranslations();

	library.add(fas, far, fad, fal, fat);
	window.addEventListener("DOMContentLoaded", () => {
		dom.i2svg();
		dom.watch();
	});

	app
		.use(vuetify)
		.use(router)
		.use(i18n)
		.use(PerfectScrollbarPlugin)
		.use(FloatingVue)
		.use(VCalendar, {
			componentPrefix: "vc",
		})
		.directive("debounce", vue3Debounce({ lock: true }));

	initSentry(app);
	initChartJs();

	return app;
}
